

import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import './CoinPercentUse.css';
import api from '../../api/axios';

const CoinPercentUse = () => {
  const [price, setPrice] = useState('');
  const [currentPrice, setCurrentPrice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  /* ================= HISTORY STATE ================= */
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    fetchCurrentPrice();
    fetchHistory(page);
  }, [page]);

  const fetchCurrentPrice = async () => {
    try {
      const res = await api.get('/coin-percent');
      console.log('res', res);
      setCurrentPrice(res.data?.coinPercentUse?.percentageUsable ?? null);
    } catch (error) {
      console.error('Fetch error:', error);
      setCurrentPrice(null);
    }
  };

  const fetchHistory = async (pageNo) => {
    try {
      setHistoryLoading(true);
      const res = await api.get('/admin/history/coin-percentUse', {
        params: { page: pageNo, limit }
      });

      if (res.data.success) {
        setHistory(res.data.data);
        setPagination(res.data.pagination);
      }
    } catch (error) {
      console.error('History fetch error:', error);
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!price || Number(price) <= 0) {
      setMessage('Please enter a valid price');
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      if (currentPrice === null) {
        await api.post('/admin/coin-percentUse', { percent: Number(price) });
        toast.success('Coin percent use created successfully!');
      } else {
        if (Number(price) === Number(currentPrice)) {
          setMessage('Percent Use is already the same');
          setIsLoading(false);
          return;
        }
        await api.post('/admin/coin-percentUse', { percent: Number(price) });
        toast.success('Coin Percent uses updated successfully!');
      }

      setCurrentPrice(Number(price));
      setPrice('');
      fetchHistory(1);
      setPage(1);

      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error:', error);
      setMessage(error.response?.data?.message || 'Error setting coin price');
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= DATE FORMATTER ================= */
  const formatDateTime = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="coin-price">
      <div className="coin-price-header">
        <h2>Coin Percent Use Management</h2>
      </div>

      <div className="coin-price-content">
        <div className="current-price-section">
          <h3>Current Coin Percent Use</h3>
          <div className="current-price-display">
            {currentPrice || 25}%
          </div>
        </div>

        <div className="update-price-section">
          <h3>Update Coin Percent Use</h3>
          <form onSubmit={handleSubmit} className="price-form">
            <div className="input-group">
              <label htmlFor="price">New Percent Uses (%)</label>
              <input
                type="number"
                id="price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter coin percent use"
                min="0"
                step="0.01"
                required
              />
            </div>

            <button type="submit" className="update-btn" disabled={isLoading}>
              {isLoading ? 'Updating...' : 'Update Percent Uses'}
            </button>
          </form>

          {message && (
            <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
              {message}
            </div>
          )}
        </div>
      </div>

      {/* ================= HISTORY TABLE (NEW) ================= */}
      <div className="coin-history-section">
        <h3>Coin Percent Use History</h3>

        <div className="table-container">
          <table className="coin-history-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Percent Uses (%)</th>
                <th>Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {historyLoading ? (
                <tr>
                  <td colSpan="3" align="center">Loading...</td>
                </tr>
              ) : history.length === 0 ? (
                <tr>
                  <td colSpan="3" align="center">No history found</td>
                </tr>
              ) : (
                history.map((item, index) => (
                  <tr key={item._id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{item.percentageUsable}%</td>
                    <td>{formatDateTime(item.createdAt)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>
            Prev
          </button>
          <span>
            {page} / {pagination.totalPages || 1}
          </span>
          <button
            disabled={page === pagination.totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            Next
          </button>
        </div>
      </div>
      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default CoinPercentUse;
